import { AlertTriangle, Trash2 } from 'lucide-react'
import { Button, Modal, ModalActions } from '../ui'
import styles from './DeleteConfirmDialog.module.css'

const cssClass = (...classNames: Array<string | undefined>): string =>
  classNames.filter(Boolean).join(' ')

type DeleteConfirmDialogProps = {
  confirmLabel?: string
  description: string
  isDeleting?: boolean
  itemName: string
  onCancel: () => void
  onConfirm: () => Promise<void> | void
  title: string
}

export const DeleteConfirmDialog = ({
  confirmLabel = 'Delete',
  description,
  isDeleting = false,
  itemName,
  onCancel,
  onConfirm,
  title
}: DeleteConfirmDialogProps) => {
  return (
    <Modal
      ariaLabelledBy="delete-confirm-title"
      backdropClassName="delete-confirm-backdrop"
      isDismissDisabled={isDeleting}
      onClose={onCancel}
      panelClassName={cssClass(styles.panel)}
      title={(
        <span className={styles.icon} aria-hidden="true">
          <AlertTriangle size={20} />
        </span>
      )}
    >
      <div className={styles.copy}>
        <h2 id="delete-confirm-title">{title}</h2>
        <p>{description}</p>
        <strong>{itemName}</strong>
      </div>
      <ModalActions>
        <Button disabled={isDeleting} onClick={onCancel} variant="secondary">
          Cancel
        </Button>
        <Button disabled={isDeleting} icon={<Trash2 size={16} />} onClick={() => void onConfirm()} variant="destructive">
          {isDeleting ? 'Deleting...' : confirmLabel}
        </Button>
      </ModalActions>
    </Modal>
  )
}
